export const removeProtocolFromUrl = (url: string): string => url.replace(/(^\w+:|^)\/\//, '');

export const getLinkWithTraciParams = (link: string, brand: string, label: string): string =>
    `${link}?traci_s=EXW:${brand.toUpperCase()}:ORG:CP:Website:2022-07:MarketingCard&traci_ie=${removeProtocolFromUrl(
        window.location.href,
    )}:Content:Button:1:${label}`;
